import styled from 'styled-components';
import { s } from '../components/PeriodStatsPage.styles';
import AuctionTrendAnalysisChart, {
  type TrendRow,
} from './graph/AuctionTrendAnalysisGraph';
// import SaveAsImageButton from '../../../components/button/SaveAsImageButton';
import { useRef, useMemo } from 'react';
import { downloadAsExcel } from '../../../utils/downloadAsExcel';
import SaveAsImageButton from '../../components/button/SaveAsImageButton';

type AuctionTrendsAnalysisProps = {
  region: string;
  usage: string;
  usageDetail?: string;
  court?: string;
  data: TrendRow[];
  loading?: boolean;
  error?: string | null;
};

export default function AuctionTrendsAnalysis({
  region,
  usage,
  usageDetail,
  court,
  data = [],
  loading = false,
  error = null,
}: AuctionTrendsAnalysisProps) {
  const targetRef = useRef<HTMLDivElement>(null);

  // 엑셀 저장: 화면과 동일한 컬럼명으로 구성
  const handleDownloadExcel = () => {
    const rows = data.map((r) => ({
      기간: r.label,
      진행건수: r.progress,
      낙찰건수: r.wonCount,
      '낙찰률(%)': Number(r.winRate.toFixed(1)),
      '낙찰가율(%)': Number(r.winPriceRate.toFixed(1)),
      평균응찰자수: Number(r.avgBidders.toFixed(1)),
    }));
    downloadAsExcel(rows as any[], '경매_동향_분석_데이터');
  };

  return (
    <s.Wrap ref={targetRef}>
      <s.Header>
        <s.HeaderRow>
          <s.Img $bg="#FEEFFC">
            <img src="/assets/images/icon/pink_arrow.svg" alt="" />
          </s.Img>
          <s.ButtonDiv>
            <SaveAsImageButton
              targetRef={targetRef}
              fileName="경매_동향_분석.png"
            />
            <s.ExcelButton onClick={handleDownloadExcel} aria-label="엑셀 저장">
              <img src="/assets/images/icon/download-black.svg" alt="" />
            </s.ExcelButton>
          </s.ButtonDiv>
        </s.HeaderRow>
        <s.TitleBox>
          <h3>경매 동향 분석</h3>
          <p>진행/낙찰 건수, 낙찰률, 낙찰가율, 평균 응찰자 수 추이</p>
          <s.SelectedOptionBox>
            <s.SelectedOption>
              {court && court !== 'all' ? court : `${region} 지역`}
            </s.SelectedOption>
            <s.SelectedOption>
              {usage === '전체'
                ? `${usage} 용도`
                : `${usage} ${usageDetail ? ` ${usageDetail} 용도` : ''}`}
            </s.SelectedOption>
          </s.SelectedOptionBox>
        </s.TitleBox>
      </s.Header>

      {loading ? (
        <LoaderWrap>
          <LoaderImg
            src="/assets/images/icon/loader.gif"
            alt="경매 동향 분석"
          />
        </LoaderWrap>
      ) : (
        <AuctionTrendAnalysisChart data={data} />
      )}
    </s.Wrap>
  );
}

const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  width: 100%;
`;

const LoaderImg = styled.img`
  width: 24px;
  height: 24px;
`;
